<main class="bggraddiv">
    <div class="container"  *ngIf="!successregistration">
        
        <div class="row justify-content-center 
        pt-5 pb-5
        ps-3 pe-3
        ps-sm-0 pe-sm-0
        ps-md-0 pe-md-0
        ps-lg-0 pe-lg-0
        g-0">
            <div class="col-sm-12 col-md-12 col-lg-9 divshadow containerlogin">
                <div class="row g-0">
                    <div class="col-sm-12 col-md-6 col-lg-6 bglogin d-none d-md-block">
                        <!-- <div class="row">
                            <div class="col-9">
                                <div class="py-5 my-3 text-start">
                                    <img src="/assets/auth/register/title.png" class="ms-3" data-aos="fade-up">
                                    <img src="/assets/auth/register/subtitle.png" class="ms-3" data-aos="fade-up" data-aos-delay="200">
                                </div>
                                <div class="text-start">
                                    <img src="/assets/auth/register/benefit list 1.png" class="ms-3" data-aos="fade-up" data-aos-delay="500"><br>
                                    <img src="/assets/auth/register/benefit list 2.png" class="ms-3" data-aos="fade-up" data-aos-delay="700"><br>
                                    <img src="/assets/auth/register/benefit list 3.png" class="ms-3" data-aos="fade-up" data-aos-delay="900"><br>
                                    <img src="/assets/auth/register/benefit list 4.png" class="ms-3" data-aos="fade-up" data-aos-delay="1100"><br>
                                    <img src="/assets/auth/register/benefit list 5.png" class="ms-3" data-aos="fade-up" data-aos-delay="1300"><br>
                                    <img src="/assets/auth/register/benefit list 6.png" class="ms-3" data-aos="fade-up" data-aos-delay="1500"><br>

                                    
                                </div>
                            </div>
                            <div class="col-3"></div>
                        </div> -->
                        <!-- <div id="carouselRegister" class="carousel slide h-100  d-flex align-items-center " data-bs-ride="carousel"  data-interval="3000">
                            <div class="carousel-indicators">
                              <button type="button" data-bs-target="#carouselRegister" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                              <button type="button" data-bs-target="#carouselRegister" data-bs-slide-to="1" aria-label="Slide 2"></button>
                              <button type="button" data-bs-target="#carouselRegister" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            </div>
                            <div class="carousel-inner">
                              <div class="carousel-item active">
                                <img src="/assets/images/login/Register-Img1.png" class="d-block w-100" alt="...">
                              </div>
                              <div class="carousel-item">
                                <img src="/assets/images/login/Register-Img2.png" class="d-block w-100" alt="...">
                              </div>
                              <div class="carousel-item">
                                <img src="/assets/images/login/Register-Img3.png" class="d-block w-100" alt="...">
                              </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselRegister" data-bs-slide="prev">
                              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselRegister" data-bs-slide="next">
                              <span class="carousel-control-next-icon" aria-hidden="true"></span>
                              <span class="visually-hidden">Next</span>
                            </button>
                        </div> -->
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6 bg-white bginputlogin">
                        <div class="paddinglogin regisDiv">
                            <div class="text-center mb-3 pb-2">
                                <a href="/">
                                <img src="/assets/images/logofh-cepetdapet.png" style="width: 100%; max-width: 220px;">
                                </a>
                            </div>
                            <h3 class="f2 pb-0 mb-0 texttitlelogin pb1"><strong>{{'regis.regis_title' | translate}}</strong></h3>
                            <p class="f2 pt-0 mt-0 mb-4 textlogin">{{'regis.regis_desc' | translate}}</p>

                            <form [formGroup]="registerForm" class="cd-content" (ngSubmit)="onSubmit()">



                                <div class="form-group mb-3 d-none">
                                    <label for="country" class="cdc1 text-capitalize">{{'regis.country' | translate}} <font class="text-danger">*</font></label>
                                    <select formControlName="country" [(ngModel)]="ValCountry" class="form-select form-control" [ngClass]="{ 'is-invalid': submitted && f?.country?.errors }">
                                        <option></option>
                                        <option *ngFor="let country of countries" [ngValue]="country.id">{{country.countryName}}</option>
                                    </select>
                                    <div
                                    class="errtxt"
                                    role="alert"
                                    *ngIf="submitted && f?.country?.errors"
                                    >
                                    <div *ngIf="f?.country?.errors?.required">{{'regis.country_required' | translate}}</div>
                                    </div>
                                </div>



                                <div class="form-group mb-3">
                                    <label for="email" class="cdc1 text-capitalize">{{'login.email' | translate}} <sup><i class="bi bi-info-circle pointer me-1" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'company_management.register_account.email_info' | translate}}"  container="body"></i></sup> <font class="text-danger">*</font></label>
                                    <input type="text" [(ngModel)]="ValEmail" formControlName="email" max="254" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.email?.errors }" />
                                    <div
                                    class="errtxt"
                                    role="alert"
                                    *ngIf="submitted && f?.email?.errors"
                                    >
                                    <div *ngIf="f?.email?.errors?.required">{{'login.required_email' | translate}}</div>
                                    <!-- <div *ngIf="f?.email?.errors?.email">Email must be a valid email address</div> -->
                                    <div *ngIf="f?.email?.errors?.pattern">{{'login.invalid_email' | translate}}</div>
                                    </div>
                                </div>    


                                <div class="form-group mb-3 {{ isPovExist ? 'd-none':''}}">
                                    <label for="companyname" class="cdc1 text-capitalize">{{'regis.company_name' | translate}}</label>
                                    <input type="text" [(ngModel)]="ValCompanyname" formControlName="companyname" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.companyname?.errors }" />
                                    <div
                                    class="errtxt"
                                    role="alert"
                                    *ngIf="submitted && f?.companyname?.errors"
                                    >
                                    <div *ngIf="f?.companyname?.errors?.required">{{'regis.company_name_required' | translate}}</div>
                                    </div>
                                </div>

                                <div class="mb-3 row">
                                    <div class="col-sm-12">
                                        <div class="form-check">
                                            <input type="checkbox" [(ngModel)]="tos" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f?.acceptTerms?.errors }"  (click)="openModal()" />
                                            <label for="acceptTerms" class="form-check-label pointer"  (click)="openModal()"><u>{{'regis.agree_tos' | translate}}</u></label>
                                            <!-- <div *ngIf="submitted && f?.acceptTerms?.errors" class="invalid-feedback">Agree to Term and Condition is required</div> -->
                                        </div>
                                    </div>
                                </div>

    
                                <div class="mb-3 row">

                                    <div class="col-sm-12">
                                        <!-- <re-captcha
                                        (resolved)="resolved($event)"
                                        (error)="onError($event)"
                                        errorMode="handled"
                                        siteKey="6LcOuyYTAAAAAHTjFuqhA52fmfJ_j5iFk5PsfXaU"
                                      ></re-captcha> -->
    
                                      <!-- <div *ngIf="cpatchaText=='' ? 'd-none' : '' "> capcha required </div> -->
    
                                           
    
                                        <re-captcha
                                            [(ngModel)]="cpatchaText"
                                            name="captcha"
                                            formControlName="inputcaptcha"
                                            
                                            siteKey="{{config.captchaKey}}"
                                        ></re-captcha> <!--  required -->
    
    
                                        <!-- <div class="invalid-feedback">
                                            <div [hidden]="f?.inputcaptcha?.valid || f?.inputcaptcha?.pristine">Captcha must be solved</div>
                                            <div [hidden]="f?.form?.valid">Captcha is required</div>
                                        </div> -->
    
                                        <!-- <div [hidden]="f?.inputcaptcha?.valid || f?.inputcaptcha?.pristine" class="invalid-feedback">
                                            Captcha must be solved
                                        </div>
                                        <div [hidden]="!f?.inputcaptcha?.valid" class="success">Captcha is valid</div>
                                        <div [hidden]="f?.form?.valid" class="invalid-feedback">
                                            The form must be filled out
                                        </div>
                                        <div [hidden]="!f?.form?.valid" class="success">
                                            The form is valid
                                        </div> -->
    
    
                                        <div *ngIf="submitted">
                                            <div class="errmsg"  [hidden]="f?.inputcaptcha?.valid">
                                                {{'regis.captcha_required' | translate}}
                                            </div>
                                        </div>   
    
                                    </div>
                                </div>


                                <div class="form-group mt-3">
                                    <button *ngIf="!pageloading" class="f2 btn btn-secondary btn-block w-100 pt-2 pb-2 cdbtn2">
                                        {{'regis.submit' | translate}}
                                    </button>
                                    <button *ngIf="pageloading" class="f2 btn btn-secondary btn-block w-100 pt-2 pb-2 cdbtn2" disabled>
                                    Loading..
                                    </button>
                                    
                                </div>




                                <div class="form-group mt-3 text-center">
                                    <div class="col-12">
                                    
                                    </div>
                                    <div class="col-12 tb">
                                        <p class="f2 rememberme cdc1">
                                            <a href="login">{{'login.already_have_accout' | translate}} 
                                            <strong><font class="cdc1 rememberme">{{'login.login_here' | translate}}</font> </strong> </a>
                                        </p>    
                                    </div>
                                    <div class="col-12 tb border-0">
                                        <p class="f2 rememberme mb-1 cdc1">
                                            <strong>
                                                
                                        <a (click)="clickReffcode()" class="cdc1 rememberme pointer">{{'regis.referral' | translate}}
                                           <small><i class="bi bi-chevron-{{showRefCode?'up':'down'}}"></i></small> 
                                        </a> </strong></p> 
                                        <div *ngIf="showRefCode">
                                            
                                            <input type="text" class="form-control" maxlength="10" placeholder="Input Referral Code" aria-label="Input Referral Code" aria-describedby="button-addon2"  [(ngModel)]="ValReference" [ngModelOptions]="{standalone: true}" [disabled]="isFromUrl">
                                            <input type="hidden" class="form-control" maxlength="10" placeholder="Input Referral Code" aria-label="Input Referral Code" aria-describedby="button-addon2"  [(ngModel)]="ValReference" [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>


                                </div>
                                <!-- <div class="form-group">
                                    <div
                                    class="alert alert-danger mt-1 p-2"
                                    role="alert"
                                    *ngIf="f.submitted && isLoginFailed"
                                    >
                                    {{ errorMessage }}
                                    </div>
                                </div> -->





                            </form> 
                        </div>
                           
                    </div>
                </div>
            </div>
        </div>


        
        <div class="bggradlayer"></div> 
    </div>
    
                      
    <div class="container" *ngIf="successregistration">
        <div class="row justify-content-md-center pt-5 pb-5">

            <div class="col-md-6">
              
              <div class="card divshadow mt-5 mb-5 modal-content cd-modal">
                <div class="card-body pb-5">
                    <div class="text-center">
                        <a href="/"><img class="img-fluid fh-logo-div pt-2 pb-2" src="/assets/images/logofh-cepetdapet.png"></a>
                    </div>

                    <br>

                    
                    <div class="text-center">
                        <img src="/assets/modal/email-send-filled@3x.png" style="max-width: 100px;" class="img-fluid">
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-9 text-center ">
                            <h3 class="cdc1 cd-header py-2 fw-bold">{{'regis.email_verification'|translate}}</h3>
                            <h5 class="card-title cd-text cdc1">{{'regis.email_verification_text'|translate}}</h5>
                        </div>
                    </div>
                  
                  <p></p>
                  <!-- <h5 class="card-title">Thanks for your registration, please check your inbox!</h5>
                  <p class="card-text">We have sent an activation link to your email. If you did not receive it please check your spam folder. Do contact us when you can’t find the confirmation mail. Please click the link provided in the email to finalise your registration.</p> -->

                  <div class="text-center">
                    <a href="/" class="text-center fw-bold btn btn-secondary btn-block w-50 cdbtn2 pt-2 pb-2">{{'back'|translate}}</a>
                  </div>
                  
                </div>
              </div>
            </div>

        </div>
        <div class="bggradlayer"></div> 
    </div>                                 
    
                    
</main>


      <!-- Modal -->
      <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> -->
      <div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content  border-0 cd-modal">
            <div class="modal-header cdbg2   text-center">
              <h5 class="modal-title text-white text-capitalize cd-sub-header w-100" id="exampleModalLabel">{{'regis.tos' | translate}}</h5>
              <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button> -->
            </div>
            <div class="modal-body">
                <div class="pt-3 pb-3 pe-4 ps-4 border-1">
                    <!-- <object *ngIf="tac" 
                    [data]="getSafeUrl(tac?.description)"
                    type="application/pdf"
                    width="100%"
                    height="400px">
                    </object> -->

                    <div class="text-center">
                        <img src="/assets/images/logofh-cepetdapet.png" style="width: 100%; max-width: 220px;">
                    </div>

                        <div  *ngIf="TnCsrc" >
                            <pdf-viewer 
                            [src]="TnCsrc" 
                            [original-size]="false"
                            [show-all]="true"
                            [fit-to-page]="false"
                            [zoom]="1"
                            [zoom-scale]="'page-width'"
                            [stick-to-page]="false"
                            [render-text]="true"
                            [external-link-target]="'blank'"
                            [autoresize]="true"
                            [show-borders]="false"
                            style="width: 100%; height: 400px;"
                            >
                            </pdf-viewer>
                        </div>

                </div>
                <div class="pt-3 pb-3 pe-4 ps-4 text-end">
                    <div class="row">
                        <div class="col-6">
                            <button type="button" class="btn border-1 cdborder2 cd-text text-capitalize w-100 cdoutbtn2 fw-bold" data-bs-dismiss="modal" (click)="closeModal('N')">{{'decline' | translate}}</button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn border-1 cdborder2 btn-secondary cd-text text-capitalize w-100 cdbtn2 fw-bold" data-bs-dismiss="modal" (click)="closeModal('Y')">{{'agree' | translate}}</button>
                        </div>
                    </div>

                    
                    
                </div>
            </div>
            <!-- <div class="modal-footer">

            </div> -->
          </div>
        </div>
      </div>
  

<app-footer></app-footer>